import { render, staticRenderFns } from "./LabelSettings.vue?vue&type=template&id=25241178&scoped=true"
import script from "./LabelSettings.vue?vue&type=script&lang=js"
export * from "./LabelSettings.vue?vue&type=script&lang=js"
import style0 from "./LabelSettings.vue?vue&type=style&index=0&id=25241178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25241178",
  null
  
)

export default component.exports